<template>
  <div>
    <div class="content-wrap pt12 pl16 pr16">
      <div class="top-content fs12">
        <!-- body -->
        <div class="contents fs12">
          <div class="text-detail mb10">
            <p class="center">
              {{ $t("Verification.userInfo.topNoti") }}
            </p>
          </div>
          <div class="content-wrap">
            <!-- 신원인증 일자 관련 박스 -->
            <!-- <div class="date-box">
              <ul flex fjb>
                <li class="date">
                  {{$t("Verification.userInfo.topBox[0]")}}
                </li>
                <li class="date">{{String(authUserInfo.firstRegDate).slice(0, 10)}}</li>
              </ul>
              <ul class="mt12" flex fjb>
                <li class="date">
                  {{$t("Verification.userInfo.topBox[1]")}}
                 </li>
                <li class="date">{{String(authUserInfo.sbDate).slice(0, 10)}}</li>
              </ul>
              <ul class="mt12" flex fjb>
                <li class="date">
                  {{$t("Verification.userInfo.topBox[2]")}}
                </li>
                <li class="date">{{authUserInfo.reAuthDate == undefined ? "" : String(authUserInfo.reAuthDate).slice(0, 10)}}</li>
              </ul>
            </div> -->
            <!-- // 신원인증 일자 관련 박스 -->

            <!-- 신원인증 정보 -->
            <div class="info-detail mt20">
              <p class="fs14 fw500">
                {{ $t("Verification.userInfo.default.title") }}
              </p>
              <ul>
                <li class="mt8">
                  {{ $t("Verification.step3-1.checkKorean") }}
                </li>
                <li class="mt8">
                  <el-input
                    disabled
                    :value="
                      authUserInfo.koreanYn == 'Y'
                        ? $t('Verification.step1.checkKorean.description[0]')
                        : $t('Verification.step1.checkKorean.description[1]')
                    "
                  ></el-input>
                </li>
              </ul>
              <ul class="mt12">
                <li class="mt8">
                  {{ $t("Verification.step3-1.nationality") }}
                </li>
                <li class="mt8">
                  <el-input disabled :value="authUserInfo.nation"></el-input>
                </li>
              </ul>
              <ul class="mt12">
                <li class="mt8">
                  {{ $t("Verification.step3-1.checkKoreanResidence") }}
                </li>
                <li class="mt8">
                  <el-input
                    disabled
                    :value="
                      authUserInfo.domesticYn == 'Y'
                        ? $t('Verification.userInfo.default.live[0]')
                        : $t('Verification.userInfo.default.live[1]')
                    "
                  ></el-input>
                </li>
              </ul>
              <ul class="mt12">
                <li class="mt8">
                  {{ $t("Verification.step3-1.country") }}
                </li>
                <li class="mt8">
                  <el-input
                    disabled
                    :value="authUserInfo.residenceNation"
                  ></el-input>
                </li>
              </ul>
              <ul class="mt12">
                <li class="mt8">
                  {{ $t("Verification.step3-1.name") }}
                </li>
                <li class="mt8">
                  <el-input disabled :value="authUserInfo.name"></el-input>
                </li>
              </ul>
              <ul class="mt12">
                <li class="mt8">
                  {{ $t("Verification.step3-1.englishName") }}
                </li>
                <li class="mt8" flex fjb>
                  <el-input
                    disabled
                    :value="authUserInfo.engName1"
                    class="half"
                  ></el-input>
                  <el-input
                    disabled
                    :value="authUserInfo.engName2"
                    class="half"
                  ></el-input>
                </li>
              </ul>
              <!-- 주민등록번호(외국인등록번호) -->
              <ul
                v-if="
                  !(
                    authUserInfo.nationCode !== 'KR' &&
                    authUserInfo.kycCode !== 'KR'
                  )
                "
                class="mt12"
              >
                <li class="mt8">
                  {{ $t("Verification.step3-1.foreignerNumber.title") }}
                </li>
                <li class="mt8">
                  <el-input
                    disabled
                    :value="idNumberMasking(authUserInfo.inIdNum)"
                  ></el-input>
                </li>
              </ul>
              <!-- 운전면허번호 -->
              <ul v-if="authUserInfo.driverLicenseNo" class="mt12">
                <li class="mt8">
                  {{ $t("Verification.step3-1.driverLicense.title") }}
                </li>
                <li v-if="Server.version < 10" class="mt8" flex fjb>
                  <el-input
                    disabled
                    :value="driversLicenseMasking(authUserInfo.driverLicenseNo)"
                  ></el-input>
                </li>
                <li v-else class="mt8" flex fjb>
                  <el-input
                    disabled
                    :value="authUserInfo.driverLicenseNo"
                  ></el-input>
                </li>
              </ul>
              <!-- 운전면허 식별번호 -->
              <ul v-if="authUserInfo.serialNo" class="mt12">
                <li class="mt8">
                  {{ $t("Verification.step3-1.serialNo.title") }}
                </li>
                <li v-if="Server.version < 10" class="mt8" flex fjb>
                  <el-input
                    disabled
                    :value="driverUniqueMasking(authUserInfo.serialNo)"
                  ></el-input>
                </li>
                <li v-else class="mt8" flex fjb>
                  <el-input disabled :value="authUserInfo.serialNo"></el-input>
                </li>
              </ul>
              <!-- //내국인/ 국내 거주 외국인 주민등록번호/외국인등록번호 노출 -->
              <ul class="mt12">
                <li class="mt8">
                  {{ $t("Verification.step3-1.phoneNumber") }}
                </li>
                <li class="mt8">
                  <el-input
                    disabled
                    :value="phoneNumberMasking(authUserInfo.mobNumber)"
                  ></el-input>
                </li>
              </ul>
              <ul class="mt12">
                <li class="mt8">
                  {{ $t("Verification.step3-1.address") }}
                </li>
                <li class="mt8">
                  <el-input
                    disabled
                    :value="addrMasking(authUserInfo.addr2 || '')"
                  ></el-input>
                  <!-- <el-input v-else disabled :value="authUserInfo.addr2"></el-input> -->
                </li>
              </ul>
            </div>
            <!-- //신원인증 정보 -->

            <!-- 필수정보 -->
            <div class="add-info mt20">
              <p class="fs14 fw500">
                {{ $t("Verification.step3-2.requiredInformation") }}
              </p>
              <!-- 직업 -->
              <ul>
                <li class="mt8">
                  {{ $t("Verification.step3-2.job.title") }}
                </li>
                <li class="mt8">
                  <el-input disabled :value="jobTitle"></el-input>
                </li>
              </ul>
              <!-- // 직업 -->
              <!-- 거래목적 -->
              <ul>
                <li class="mt8">
                  {{ $t("Verification.step3-2.purposeOfTransaction.title") }}
                </li>
                <li class="mt8">
                  <el-input
                    disabled
                    :value="
                      $t(
                        `Verification.step3-2.purposeOfTransactionItems.${authUserInfo.tradePur}.title`
                      )
                    "
                  ></el-input>
                </li>
              </ul>
              <!-- // 거래목적 -->
              <!-- 자금 출처 -->
              <ul>
                <li class="mt8">
                  {{ $t("Verification.step3-2.SourceOfFunds.title") }}
                </li>
                <li class="mt8">
                  <el-input
                    disabled
                    :value="
                      $t(
                        `Verification.step3-2.SourceOfFundsItems.${authUserInfo.capiOrigin}.title`
                      )
                    "
                  ></el-input>
                </li>
              </ul>
              <!-- // 자금 출처 -->
              <!-- 실제 소유자여부 -->
              <ul>
                <li class="mt8">
                  {{ $t("Verification.step3-2.ownershipOfFunds.title") }}
                </li>
                <li class="mt8">
                  <el-input
                    disabled
                    :value="
                      $t(
                        'Verification.step3-2.ownershipOfFundsItems.A0101.title'
                      )
                    "
                  >
                  </el-input>
                </li>
              </ul>
              <!-- // 실제 소유자여부 -->
            </div>
            <!-- //필수정보 -->
            <!-- 추가정보 -->
            <div
              v-if="
                authUserInfo.jobCategory == 1 || authUserInfo.jobCategory == 2
              "
              class="add-info mt20"
            >
              <p class="fs14 fw500">
                {{ $t("Verification.step3-3.additionalInformation") }}
              </p>
              <!-- 직장인, 전문직 고위험 -->
              <div v-if="authUserInfo.jobCategory == 1" class="case-officer">
                <ul>
                  <li class="mt8">
                    {{ $t("Verification.step3-3.companyName.title") }}
                  </li>
                  <li class="mt8">
                    <el-input
                      disabled
                      :value="jobNameMasking(authUserInfo.jobName || '')"
                    ></el-input>
                  </li>
                </ul>
                <ul>
                  <li class="mt8">
                    {{ $t("Verification.step3-3.department.title") }}
                  </li>
                  <li class="mt8">
                    <el-input
                      disabled
                      :value="jobNameMasking(authUserInfo.deptName || '')"
                    ></el-input>
                  </li>
                </ul>
                <ul>
                  <li class="mt8">
                    {{ $t("Verification.step3-3.spot.title") }}
                  </li>
                  <li class="mt8">
                    <el-input
                      disabled
                      :value="authUserInfo.position || ''"
                    ></el-input>
                  </li>
                </ul>
                <ul>
                  <li class="mt8">
                    {{ $t("Verification.step3-3.companyNumber.title") }}
                  </li>
                  <li class="mt8">
                    <el-input
                      disabled
                      :value="phoneNumberMasking(authUserInfo.jobNumber || '')"
                    ></el-input>
                  </li>
                </ul>
                <ul>
                  <li class="mt8">
                    {{ $t("Verification.step3-3.companyAddress.title") }}
                  </li>
                  <li class="mt8">
                    <el-input
                      disabled
                      :value="addrMasking(authUserInfo.jobAddr2 || '')"
                    ></el-input>
                  </li>
                </ul>
              </div>
              <!-- //직장인, 전문직 고위험 -->

              <!-- 개인사업자/자영업자 -->
              <div v-if="authUserInfo.jobCategory == 2" class="case-industry">
                <ul>
                  <li class="mt8">
                    {{ $t("Verification.step3-3.businessName.title") }}
                  </li>
                  <li class="mt8">
                    <el-input
                      disabled
                      :value="jobNameMasking(authUserInfo.bizNm || '')"
                    ></el-input>
                  </li>
                </ul>
                <ul>
                  <li class="mt8">
                    {{ $t("Verification.step3-3.businessNumber.title") }}
                  </li>
                  <li class="mt8">
                    <el-input
                      disabled
                      :value="
                        phoneNumberMasking(authUserInfo.bizIdNumber || '')
                      "
                    ></el-input>
                  </li>
                </ul>
                <ul>
                  <li class="mt8">
                    {{ $t("Verification.step3-3.businessType.title") }}
                  </li>
                  <li class="mt8">
                    <el-input
                      disabled
                      :value="jobNameMasking(authUserInfo.induty || '')"
                    ></el-input>
                  </li>
                </ul>
                <ul>
                  <li class="mt8">
                    {{ $t("Verification.step3-3.businessCreated.title") }}
                  </li>
                  <li class="mt8">
                    <el-input
                      disabled
                      :value="authUserInfo.foundDate || ''"
                    ></el-input>
                  </li>
                </ul>
                <ul>
                  <li class="mt8">
                    {{ $t("Verification.step3-3.businessContact.title") }}
                  </li>
                  <li class="mt8">
                    <el-input
                      disabled
                      :value="phoneNumberMasking(authUserInfo.bizNumber || '')"
                    ></el-input>
                  </li>
                </ul>
                <ul>
                  <li class="mt8">
                    {{ $t("Verification.step3-3.businessAddress.title") }}
                  </li>
                  <li class="mt8">
                    <el-input
                      disabled
                      :value="addrMasking(authUserInfo.bizAddr2 || '')"
                    ></el-input>
                  </li>
                </ul>
              </div>
              <!-- //개인사업자/자영업자 -->
            </div>
            <!-- //추가정보 -->
          </div>
          <div class="line" />
        </div>
        <!-- //body -->
      </div>
      <div class="bottom-button pt20 pb20">
        <div class="button-wrap">
          <button @click="clickOk" class="ok">
            {{ $t("confirm.ok") }}
          </button>
          <!-- <button
            @click="clickReAuth"
            :disabled="userInfo.dueDiligenceInfo.sbStatus == 'RE'"
            class="re-auth half ml8"
          >
            {{ $t("Verification.common.reauth") }}
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Masking from "@/common/masking.js";
import Api from "@/common/Api";
import { mapState, mapGetters } from "vuex";

export default {
  async created() {
    const res = await Api.User.getAuthUserInfo();
    this.authUserInfo = res.data.result; //신원인증 유저 정보
    const jobData = await Api.getJobData();
    this.jobData = jobData.data.result.data.job; // 신원인증 job data
  },
  data() {
    return {
      authUserInfo: {}, //신원인증 유저 정보
      jobData: [], // 신원인증 job data
      // jobTitle: ""
    };
  },
  computed: {
    ...mapState(["Server"]),
    ...mapGetters(["userInfo"]),
    jobTitle() {
      return this.getJobTitle();
    },
  },
  methods: {
    clickOk() {
      this.$router.push({ name: "confirm" });
    },
    clickReAuth() {
      CookieControl.setCookie("retry", "Y");
      this.$router.push({
        name: "authID",
        query: { reAuth: "Y" },
      });
    },
    // 주민등록번호 마스킹 : 뒤 여섯자리
    idNumberMasking(_value) {
      return Masking.idNumberMasking(_value);
    },
    // 전화번호 마스킹 : 뒤 3자부터 4자
    phoneNumberMasking(_value) {
      return Masking.phoneNumberMasking(_value);
    },
    // 주소 마스킹 : 'ㅇㅇ로' 다음
    addrMasking(_value) {
      return Masking.addrMasking(_value);
    },
    // 직장명, 부서명, 업체명 마스킹 : 앞 두 자리
    jobNameMasking(_value) {
      return Masking.jobNameMasking(_value);
    },
    // 사업자등록번호 마스킹 : 뒤 3자리부터 4자리
    bizIdNumberMasking(_value) {
      return Masking.bizIdNumberMasking(_value);
    },
    // 계좌번호 마스킹 : 7자리부터 적용
    accountMasking(_value) {
      return Masking.accountMasking(_value);
    },
    // 운전면허번호 : 뒤 3부터 6자
    driversLicenseMasking(_value) {
      return Masking.driversLicenseMasking(_value);
    },
    // 운전면허식별번호 : 뒤 3자
    driverUniqueMasking(_value) {
      return Masking.driverUniqueMasking(_value);
    },
    getJobTitle() {
      const jobDetail = ["01", "03", "05"];
      const codeSlice = String(this.authUserInfo.job).slice(0, 2); // 직업 코드의 앞 2자리)
      const result = jobDetail.includes(codeSlice);
      if (result) {
        return this.$t(
          `Verification.step3-2.jobItems.${codeSlice}` +
            `000` +
            `.detail.${this.authUserInfo.job}`
        );
      } else {
        return this.$t(
          `Verification.step3-2.jobItems.${this.authUserInfo.job}.title`
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
}
.half {
  width: calc(calc(100% - 8px) / 2);
}
.ok {
  width: 100%;
  height: 48px;
}
.re-auth {
  width: calc(100% - 78px);
}
.date-box {
  padding: 11px 12px;
  border: solid 1px #dcdfe3;
  border-radius: 4px;
}
</style>
